import { PermissionsEnum } from "@/auth/interfaces";
import { hasPermission, sizeTab, a11yProps } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { TableAuditorialog } from "../../components";
import { AuditoriaEstadisticasPage } from "@/erp/administration/auditoria/components/AuditoriaEstadisticasPage";

export default function AuditorialogPage() {

  hasPermission(PermissionsEnum.api_view_auditorialog)

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene title={"Auditoría del Sistema"}
      py={2}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 3 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs auditoria"
        >
          <Tab label={'Logs Auditoría'} {...a11yProps(0)} />
          <Tab label={'Estadísticas'} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableAuditorialog />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <AuditoriaEstadisticasPage />
      </CustomTabPanel>

    </SingleTableBoxScene >
  )
}
